// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MainContainer_wrapper__TehWt","noIframeWrapper":"MainContainer_noIframeWrapper__4GSgb"};